import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CurrencyPipe} from "@cybfed/shared/pipes/currency.pipe";
import {TranslateModule} from "@ngx-translate/core";
@Component({
    selector: 'app-sticker-ad-item',
    templateUrl: './sticker-ad-item.component.html',
    standalone: true,
    imports: [
        CurrencyPipe,
        TranslateModule
    ]
})
export class StickerAdItemComponent implements OnInit {
    @Input() item!: any;
    @Output() onRemove = new EventEmitter();
    @Output() onEdit = new EventEmitter();
    constructor(

    ) { }

    ngOnInit(): void {

    }

    remove(){
        this.onRemove.emit(this.item._id);
    }

    edit() {
        this.onEdit.emit(this.item._id);
    }
}
